import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';

var Status = /*#__PURE__*/function (_Component) {
  _inherits(Status, _Component);

  var _super = _createSuper(Status);

  function Status(props) {
    _classCallCheck(this, Status);

    return _super.call(this, props);
  }

  _createClass(Status, [{
    key: "iterateTypes",
    value: function iterateTypes(status, type, id) {
      var response = null;
      var selectedStatus = null;

      if (status[type] != null) {
        selectedStatus = status[type].find(function (t_o) {
          return t_o.id == id;
        });
      }

      if (selectedStatus != null) {
        response = selectedStatus.value;
      }

      return response;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("span", null, this.iterateTypes(this.props.status, this.props.type, this.props.id));
    }
  }]);

  return Status;
}(Component);

function mapStateToProps(state) {
  return {
    status: state.status.status
  };
}

export default connect(mapStateToProps)(Status);